@for (item of vaps; track item; let i = $index) {
  <div class="addon-expander">
    <div class="addon-expander__header">
      <a [href]="'#addon-general-field-' + item?.session_item_id" [id]="'addon-' + item?.session_item_id"
        class="addon-expander__title" data-toggle="collapse" aria-expanded="true" [ngClass]="{'collapsed': !item?.show}">
        <h6 [id]="'q' + item?.session_item_id">
          {{item?.description1?.length ? (item?.description1[0] + ' ' + item?.benefit_value | currency:'ZAR':'R ': '1.0-0') : 'Add Cover'}}
        </h6>
        <div class="addon-expander__cost">
          <p>
            <strong
              [class]="currentVap?.product_vaps_id + '-' + item?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + 'addon-' + currentVap?.product_vaps_id">
            {{item?.price | currency:'ZAR':'R ': '1.0-0'}}</strong> /mo
          </p>
        </div>
        <div class="addon-expander__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
    </div>
    <div class="addon-expander__content collapse" [ngClass]="{'show': item?.show}" [id]="'addon-general-field-' + item?.session_item_id">
      <div class="modal-addons__item">
        <div class="form-group">
          <label>{{question?.question_copy}}</label>
          <input type="text"
            placeholder="Name"
            [(ngModel)]="item.name"
            (ngModelChange)="onChange(i, 0)"
            [class]="'form-control name answers ' + question?.cent_aq_question_id"/>
          </div>
          <div class="form-group">
            <input type="text"
              placeholder="Surname"
              [(ngModel)]="item.surname"
              (ngModelChange)="onChange(i, 0)"
              [class]="'form-control surname answers ' + question?.cent_aq_question_id"/>
            </div>
            <div class="form-group">
              <input type="tel"
                placeholder="Week(s)"
                [(ngModel)]="item.option_id"
                (ngModelChange)="onChange(i, 0)"
                [class]="'form-control week answers ' + question?.cent_aq_question_id"/>
              </div>
              <div class="form-group">
                <input currencyMask
                  type="tel"
                  placeholder="Amount"
                  [options]="maskOptions"
                  [(ngModel)]="item.benefit_value"
                  [class]="'form-control amount answers ' + question?.cent_aq_question_id"
                  (ngModelChange)="onChange(i, 0)"/>
                </div>
              </div>
            </div>
          </div>
        }
